import React, { useEffect, useState } from 'react';
import { Form, FormFeedback, Input } from 'reactstrap';
import Switch from "react-switch";
import { Offsymbol, OnSymbol } from '../../../constants/holcim';
import { BaseCustomModal, GradientDecorationLine, BaseCustomButton, BaseSelectComponent } from '../../../shared';
import { useFormik } from "formik";
import * as Yup from "yup";

export const LabAreaRegisterModal = ({ setShowModal, showModal, modalRespInfo, isUpdate, rowInfo, labTypes, modalClose }) => {
    const [active, setActive] = useState(false);
    const [lockActive, setLockActive] = useState(false);

    useEffect(() => {
        setActive(isUpdate ? rowInfo.recordStatus : true);
        setLockActive(!isUpdate);
    }, [showModal]);

    const formikFormData = useFormik({
        enableReinitialize: true,
        initialValues: {
            name: isUpdate ? rowInfo.name : '',
            laboratoryType: isUpdate ? rowInfo.laboratoryType.id : '',
        },
        validationSchema: Yup.object({
            name: Yup.string().required("Ingrese el nombre del área de laboratorio"),
            laboratoryType: isUpdate ? Yup.string() : Yup.string().required("Seleccione un tipo de laboratorio"),
        }),
        onSubmit: (values) => {
            modalRespInfo(values, active);
            formikFormData.resetForm();
            setShowModal(false);
        }
    });

    const onClosed = () => {
        formikFormData.resetForm();
        modalClose();
        setShowModal(false);
    };

    const children_form = (
        <div>
            <h4 className="text-primary m-0 ps-4">Registro/Actualización de Áreas de Laboratorio</h4>
            <GradientDecorationLine />

            <Form onSubmit={formikFormData.handleSubmit} className="form-horizontal mt-3 mb-1">
                <div className="mb-3 px-5">
                    <label className='text-primary'>Nombre de Área de Laboratorio</label>
                    <Input
                        name="name"
                        className="form-control text-primary"
                        placeholder="Área de Laboratorio"
                        type="text"
                        onChange={formikFormData.handleChange}
                        onBlur={formikFormData.handleBlur}
                        value={formikFormData.values.name}
                        invalid={formikFormData.touched.name && formikFormData.errors.name}
                    />
                    {formikFormData.touched.name && formikFormData.errors.name && (
                        <FormFeedback type="invalid">{formikFormData.errors.name}</FormFeedback>
                    )}
                </div>

                <div className="mb-3 px-5">
                    <label className='text-primary'>Tipo de Laboratorio</label>
                    <BaseSelectComponent
                        options={labTypes.map((labtype) => ({ value: labtype.id, label: labtype.name }))}
                        placeholder="Seleccione tipo de laboratorio"
                        value={formikFormData.values.laboratoryType}
                        onChange={(value) => formikFormData.setFieldValue("laboratoryType", value)}
                        error="Seleccione tipo de laboratorio"
                        touched={formikFormData.touched.laboratoryType && formikFormData.errors.laboratoryType}
                        status={formikFormData.touched.laboratoryType && formikFormData.errors.laboratoryType ? 'error' : ''}
                        disabled={isUpdate}
                    />
                </div>

                <div className="px-5">
                    <div className='text-primary pb-2'>Activo</div>
                    <Switch
                        disabled={lockActive}
                        className='me-4'
                        uncheckedIcon={<Offsymbol />}
                        checkedIcon={<OnSymbol />}
                        onColor="#94C12E"
                        onChange={() => setActive(!active)}
                        checked={active}
                    />
                </div>

                <div className='mt-5'>
                    <GradientDecorationLine />
                    <div className="page-title-box d-flex justify-content-end">
                        <BaseCustomButton
                            outline
                            color="primary"
                            className='rounded-3 me-3'
                            onClick={formikFormData.handleSubmit}
                            icon='mdi mdi-content-save me-1'
                            label='Guardar'
                        />
                        <BaseCustomButton
                            outline
                            color="danger"
                            className='rounded-3'
                            onClick={onClosed}
                            icon='mdi mdi-close-circle-outline me-1'
                            label='Cancelar'
                        />
                    </div>
                </div>
            </Form>
        </div>
    );

    return (
        <BaseCustomModal
            isModalOpen={showModal}
            handleOk={onClosed}
            handleCancel={onClosed}
            footer={null}
            children={children_form}
            width={700}
        />
    );
};